import React, { useState } from "react";
import { CurrentStepSetAction } from "./../../../actions/action";
import CONSTANTS from "../../../constants";
import { connect } from "react-redux";
import chevronOrange from "../../../images/AC/ac_chevron_down_orange.png";
import vinIcon from "../../../images/AC/ac-vin-blue.png";
import kilometrageIcon from "../../../images/AC/ac-kilometrage-blue.png";
import editIcon from "../../../images/AC/ac-edit-summary.png";
import editIconBlack from "../../../images/AC/ac-edit-summary-black.png";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import { Link } from "react-router-dom";
import alertIcon from "../../../images/AC/ac-alert-white.png";

const mapStateToProps = (state) => state;
const mapDispatchToProps = { CurrentStepSetAction };

const CarSummaryFlex = (props) => {
  const [showNextEditButtonCar, setShowNextEditButtonCar] = useState(false);
  const { car, kilo } = props.store;
  const carName = car.ModelLabel + " - " + car.EnergyLabel;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rootCarContainer">
      <div className="carSectionTitleContainer">
        <div className="carSectionTitle">
          {CONSTANTS.LABELS.summary_vehicule}
        </div>
        <img
          src={chevronOrange}
          className={isOpen ? "chevronDetail isOpen" : "chevronDetail"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div
        className={
          isOpen ? "carContentContainer isOpen" : "carContentContainer"
        }
      >
        <div className="carName">{carName}</div>
        <div className="carBodyContainer">
          <div className="separatorCar"></div>
          <div className="carInfosContainer">
            <div className="sectionContainerHolder">
            <div className="sectionContainer">
              <div className="sectionTitleIconContainer">
                <img src={vinIcon} />
                <div className="sectionTitle">
                  {CONSTANTS.LABELS.summary_vehicule_vin}
                </div>
              </div>
              <div className="vinTitle">{car.SerialNumber}</div>
            </div>

            <div className="sectionContainer">
              <div className="sectionTitleIconContainer">
                <img src={kilometrageIcon} />
                <div className="sectionTitle">
                  {CONSTANTS.LABELS.summary_vehicule_km}
                </div>
              </div>
              <div className="kiloTitle">{`${kilo.kilometrage} Km`}</div>
            </div>
            </div>
            <div className="contratService">
              {kilo.contratService && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: CONSTANTS.LABELS.summary_vehicule_warranty_true,
                  }}
                ></span>
              )}

              {!kilo.contratService && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: CONSTANTS.LABELS.summary_vehicule_warranty_false,
                  }}
                ></span>
              )}
            </div>
          </div>

          {/* <div className="editButton">
            <img src={editIcon} />
            <div className="editButtonTitle">
              {CONSTANTS.LABELS.common_v2_modify}
            </div>
          </div> */}

          {((!showNextEditButtonCar &&
            props.isWithPrice &&
            !props.store.isEditMode) ||
            (!showNextEditButtonCar &&
              props.isWithPrice &&
              props.store.isEditMode &&
              !props.expiredDate)) && (
            <div
              className="editButton"
              onClick={(e) => {
                pushEventToGTM({
                  pageName: "summary",
                  eventAction: "Redirection::Internal::Modify",
                  eventLabel: "summary_modify_vehicule",
                });
                setShowNextEditButtonCar(true);
              }}
            >
              <img src={editIcon} />
              <div className="editButtonTitle">
                {CONSTANTS.LABELS.common_v2_modify}
              </div>
            </div>
          )}

          {((!showNextEditButtonCar &&
            !props.isWithPrice &&
            !props.store.isEditMode) ||
            (!showNextEditButtonCar &&
              !props.isWithPrice &&
              props.store.isEditMode &&
              !props.expiredDate)) && (
            <Link
              onClick={(e) => {
                pushEventToGTM({
                  pageName: "summary",
                  eventAction: "Redirection::Internal::Modify",
                  eventLabel: "summary_modify_vehicule",
                });
                props.CurrentStepSetAction(3);
              }}
              to={`${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}`}
            >
              <div className="editButton">
                <img src={editIcon} />
                <div className="editButtonTitle">
                  {CONSTANTS.LABELS.common_v2_modify}
                </div>
              </div>
            </Link>
          )}

          {showNextEditButtonCar && (
            <div className="linkAlertContainer">
              {
                <Link
                  className="linkConfirmation"
                  to={`${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}`}
                  onClick={(e) => props.CurrentStepSetAction(3)}
                >
                  <div className="editButton">
                    <img src={editIconBlack} />
                    <div className="editButtonTitle isConfirm">
                      {CONSTANTS.LABELS.summary_warning1_continue}
                    </div>
                  </div>
                </Link>
              }

              {/* Popin for confirmation of edit*/}
              {props.isWithPrice && (
                <div className="popinConfirm">
                  <img src={alertIcon} />
                  {CONSTANTS.LABELS.summary_warning_alert_vehicle}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CarSummaryFlex);
